import { render } from "./TicketReply.vue?vue&type=template&id=4d9ebf32&scoped=true"
import script from "./TicketReply.vue?vue&type=script&lang=js"
export * from "./TicketReply.vue?vue&type=script&lang=js"

import "./TicketReply.vue?vue&type=style&index=0&id=4d9ebf32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9ebf32"]])

export default __exports__